import React from 'react'

import i18n from 'live/services/i18n'

import { IBarrierTypeIcon } from 'plugin-codaf-risk-ext-bowtie/types'
import { IIconList, iconList as defaultIconList } from 'plugin-codaf-risk-ext-bowtie/utils/iconList'

import { IconPickerContainer, IconPickerDropdown, IconPickerGrid, InputContainer } from './styles'

interface IProps {
    selectedIcon?: string
    iconList?: IBarrierTypeIcon[]
    columns?: number
    rows?: number
    iconGroupName?: string
    label?: string
    disabled?: boolean
    onChange: (iconName: string) => void
    getIconObject: (iconObject: IBarrierTypeIcon) => void
}

export const IconPicker: React.FC<IProps> = ({
    selectedIcon,
    iconList,
    columns = 7,
    rows = 3,
    iconGroupName = 'font-awesome',
    label = i18n('Icon'),
    disabled = false,
    onChange,
    getIconObject
}) => {
    const [localSelectedIcon, setLocalSelectedIcon] = React.useState<string>()
    const [isOpen, setIsOpen] = React.useState(false)
    const [iconObject, setIconObject] = React.useState<IBarrierTypeIcon>()
    const dropdownRef = React.useRef<HTMLDivElement>(null)

    const handleOnChange = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        iconName: string,
        icon: IBarrierTypeIcon
    ): void => {
        e.preventDefault()
        setLocalSelectedIcon(iconName)
        setIconObject(icon)
        onChange(iconName)
        getIconObject(icon)
    }

    const handleSelectedIcon = (iconName: string): boolean => {
        return iconName === (selectedIcon ?? localSelectedIcon)
    }

    const handleOpen = (): void => {
        if (!disabled) {
            setIsOpen(true)
        }
    }

    React.useEffect(() => {
        function handleMouseDownAction(this: Document, ev: MouseEvent): void {
            if (dropdownRef.current && !dropdownRef.current.contains(ev.target as HTMLElement)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleMouseDownAction)

        return () => {
            document.removeEventListener('mousedown', handleMouseDownAction)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <IconPickerContainer>
            <InputContainer className={`form-group ${disabled ? 'disabled' : ''}`} onClick={handleOpen}>
                <label className="control-label">{label}</label>
                <div className="form-control">
                    <i
                        className={
                            iconList?.find(icon => icon.iconReference === (selectedIcon ?? localSelectedIcon))?.faName
                        }
                    />
                </div>
            </InputContainer>
            {isOpen && (
                <IconPickerDropdown className="icon-picker-dropdown" ref={dropdownRef}>
                    <div className="filtered-search"></div>
                    <IconPickerGrid columns={columns} rows={rows}>
                        {iconList?.map((icon, index) => (
                            <button
                                key={index + icon.iconReference}
                                className="grid-item"
                                onClick={e => handleOnChange(e, icon.iconReference, icon)}
                                disabled={icon.isAlreadyInUse || handleSelectedIcon(icon.iconReference)}
                            >
                                <i className={icon.faName} />
                            </button>
                        ))}
                    </IconPickerGrid>
                    <div className="pagination"></div>
                </IconPickerDropdown>
            )}
        </IconPickerContainer>
    )
}
